module.exports = __webpack_public_path__ + "media/images/pdf_icon-f73e0862ef7d6a5b9b2fc4c92fc775c4.png";